/* _customled-megamenu-shop-all.js — Custom LED owned
 *
 * The PRODUCTS mega-menu (maranello-categories-menu) renders EVERY top-level item
 * as a hover-flyout panel. Our "Shop All Products" item has no children, so the
 * theme builds an empty panel whose only contents is a redundant auto-generated
 * "View All Shop All Products →" link, and the top-level item is a panel TRIGGER
 * (href="#MegaMenuContentN") rather than a direct link.
 *
 * This converts that one item into a plain one-click link to /collections/all:
 *   - rewrites the anchor href to the (locale-correct) all-products URL
 *   - navigates on click regardless of the theme's own panel handlers
 *   - hides the now-empty flyout panel (CSS !important, beats theme show/hide)
 *   - hides the chevron arrow (it implied a flyout that no longer exists)
 *
 * Owned, zero vendor edits. Loaded globally (header is on every page) by
 * snippets/_customled-stylesheets.liquid, which sets window.CUSTOMLED_ALL_URL.
 * Idempotent; safe no-op if the item/markup isn't present. Mobile already renders
 * a childless item as a plain link, so this only needs to touch the desktop nav.
 *
 * THEME-UPGRADE NOTE: targets theme mega-menu markup (a.mega-menu-main-nav-item,
 * #MegaMenuContentN panels). Re-verify if Truly Fine Pixels changes that markup.
 */
(function () {
  var ALL_URL = window.CUSTOMLED_ALL_URL || '/collections/all';

  function fix() {
    var items = [].slice.call(document.querySelectorAll('a.mega-menu-main-nav-item'));
    items.forEach(function (a) {
      if (a.getAttribute('data-customled-direct')) return;
      if (a.textContent.trim().toLowerCase() !== 'shop all products') return;
      a.setAttribute('data-customled-direct', '1');

      var panelId = a.getAttribute('aria-controls') || (a.getAttribute('href') || '').replace(/^#/, '');
      a.setAttribute('href', ALL_URL);
      a.removeAttribute('aria-controls');
      a.removeAttribute('aria-expanded');
      a.removeAttribute('aria-haspopup');
      a.classList.remove('current');

      // Navigate on click even if the theme's delegated handler intercepts it.
      a.addEventListener('click', function (e) {
        e.stopPropagation();
        window.location.href = ALL_URL;
      }, true);

      // Hide the chevron arrow.
      var svg = a.querySelector('svg');
      if (svg) svg.style.display = 'none';

      // Robustly hide the empty flyout panel (theme toggles display, so use !important).
      if (panelId && /^[A-Za-z][\w-]*$/.test(panelId)) {
        var st = document.createElement('style');
        st.setAttribute('data-customled-megamenu', '');
        st.textContent = '#' + panelId + '{display:none !important;}';
        document.head.appendChild(st);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();
